import { render, staticRenderFns } from "./ReimbursementMethodIcon.vue?vue&type=template&id=60b1a5ea&"
import script from "./ReimbursementMethodIcon.vue?vue&type=script&lang=ts&"
export * from "./ReimbursementMethodIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports